// extracted by mini-css-extract-plugin
export default {"wrapper":"Loading2_wrapper__wAEN0","h3":"Loading2_h3__3aySE","flexAlign":"Loading2_flexAlign__+GPvn"};